module.exports = __webpack_public_path__ + "img/CO.7e342e02.svg";